import { createClient } from '@ceramicnetwork/rpc-window';
import { DIDRPCNameSpace } from '@3id/common';
export class DidProviderWindowProxy {
    get isDidProvider() {
        return true;
    }
    async send(msg) {
        return this._client.connection.send(msg);
    }
    constructor(target, namespace = DIDRPCNameSpace){
        this._client = createClient(namespace, target);
    }
}
